<!-- Conversation history view (PCSA-13169), shown in the panel body under the
     normal panel header (no separate back-arrow header per design). Rename is an
     inline card editor owned by each item; delete is immediate. -->
<div class="orbi-history">
  <!-- Infinite scroll (PCSA-13312): the next page loads on scroll (no "load
       more" button). onScroll guards on can-load-more + not-already-loading;
       ngAfterViewChecked auto-fills when the first pages don't overflow. -->
  <div #list class="orbi-history__list" tabindex="-1" (scroll)="onScroll($event)">
    <div class="orbi-history__items" role="list">
      <patient-ui-orbi-history-item
        *ngFor="let conversation of conversations$ | async; trackBy: trackBySessionId"
        role="listitem"
        [conversation]="conversation"
        [activeSessionId]="activeSessionId$ | async"
        [sessionLocked]="sessionLocked"
        (resumeConversation)="onResume($event)"
        (renameConversation)="onRename($event)"
        (removeConversation)="onDelete($event)"
      ></patient-ui-orbi-history-item>
    </div>

    <p *ngIf="(loading$ | async) === false && (conversations$ | async)?.length === 0" #emptyState class="orbi-history__empty" tabindex="-1">
      No conversations yet.
    </p>

    <div *ngIf="loading$ | async" class="orbi-history__loading">Loading…</div>
  </div>
</div>
